import React from 'react'
import { Box, Typography } from '@mui/material'
import { REPORT_PRIMARY_ACCENT } from '../../constants/reportUiTokens'
import { getPaymentMethodChartColor, getMotiveSliceColorByIndex } from '../../constants/reportChartColors'

export const REPORT_MOBILE_KPI_ACCENT = REPORT_PRIMARY_ACCENT

export const REPORT_EFFECTIVENESS_MOBILE_CODE_ACCENT = '#27588D'

export const EFFECTIVENESS_MOBILE_USER_EXPANDABLE_CARD_FONT_SIZE = 14

export function SummaryResumenMetricRow({ label, value, accentColor = REPORT_MOBILE_KPI_ACCENT }) {
  const valueStr = String(value)
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        py: 1.35
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          fontWeight: 600,
          letterSpacing: 0.04,
          textTransform: 'uppercase',
          lineHeight: 1.35,
          flex: '0 1 46%',
          minWidth: 0
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="h5"
        component="div"
        title={valueStr}
        sx={{
          fontWeight: 800,
          color: accentColor,
          textAlign: 'right',
          lineHeight: 1.25,
          flex: '1 1 54%',
          minWidth: 0,
          fontSize: { xs: '1.125rem', sm: '1.35rem' },
          fontVariantNumeric: 'tabular-nums',
          wordBreak: 'break-word'
        }}
      >
        {value}
      </Typography>
    </Box>
  )
}

export function buildPaymentRowsMobile(paymentMethods) {
  return [...paymentMethods]
    .filter((m) => Number(m.value) > 0)
    .sort((a, b) => b.value - a.value)
    .map((m) => ({
      text: m.text,
      value: m.value,
      color: getPaymentMethodChartColor(m.text)
    }))
}

export function buildMotiveRowsMobile(raw) {
  const withIdx = Object.entries(raw || {}).map(([text, value], originalIndex) => ({
    text,
    value,
    originalIndex
  }))
  return [...withIdx]
    .sort((a, b) => b.value - a.value)
    .map((m) => ({
      text: m.text,
      value: m.value,
      color: getMotiveSliceColorByIndex(m.originalIndex)
    }))
}
